export const DASH = '–'; // mostly used to display empty record in UI

export const MAX_PAGE_WIDTH_TABLET = 1024;
export const MAX_PAGE_WIDTH_MOBILE = 480;
